import axios from 'axios';
import lstModules from 'common/json/lstModules.json';
var tokenid = localStorage.getItem("tokenid");
var httpURLAcdYr = lstModules['academicYear'].url + ":" + lstModules['academicYear'].port;
var httpURLCommon = lstModules['main'].url + ":" + lstModules['main'].port;

function getLstAcdYrSvc(cb) {
    var obj = { status: "Success" }
    axios({
        url: httpURLAcdYr + '/sms/acdyr/list',
        method: "POST",
        params: {},
        headers: { 'tokenid': tokenid },
        withCredentials: true,
    }).then((response) => {

        obj.status = response.data.SvcStatus;
        obj.message = response.data.SvcMsg;
        if (response.data.SvcStatus === 'Success') {
            obj.lstAcademicYear = response.data.lstAcademicYear;
        } else {
            obj.lstAcademicYear = [];
        }
        // this.fillAcademicYearCmb();
        cb(obj)

    }).catch((error) => {
        obj.status = 'Exception';
        obj.message = 'Service Failed ' + error;
        obj.lstAcademicYear = []
        cb(obj)
    });
}
function calcDueSvc(fromYrId, toYrId, cb) {
    var obj = { status: "Success" }
    axios({
        url: httpURLAcdYr + '/sms/acdyr/feedue/carry_forward',
        method: "POST",
        params: { 'oldAcdYrId': fromYrId, 'newAcdYrId': toYrId },
        headers: { 'tokenid': tokenid },
        withCredentials: true,
    }).then((response) => {

        obj.status = response.data.SvcStatus;
        obj.message = response.data.SvcMsg;
        cb(obj)

    }).catch((error) => {
        obj.status = 'Exception';
        obj.message = 'Service Failed ' + error;
        cb(obj)
    });
}

function createClsSecSvc(fromYrId, toYrId, cb) {
    var obj = { status: "Success" }
    axios({
        url: httpURLCommon + '/sms/promote/section/create',
        method: "POST",
        params: { 'fromAcdYrId': fromYrId, 'toAcdYrId': toYrId },
        headers: { 'tokenid': tokenid },
        withCredentials: true,
    }).then((response) => {

        obj.status = response.data.SvcStatus;
        obj.message = response.data.SvcMsg;
        cb(obj)

    }).catch((error) => {
        obj.status = 'Exception';
        obj.message = 'Service Failed ' + error;
        cb(obj)
    });
}
export { getLstAcdYrSvc, calcDueSvc, createClsSecSvc }